import { render, staticRenderFns } from "./bacthRole.vue?vue&type=template&id=77f8a6fb&scoped=true&"
import script from "./bacthRole.vue?vue&type=script&lang=js&"
export * from "./bacthRole.vue?vue&type=script&lang=js&"
import style0 from "./bacthRole.vue?vue&type=style&index=0&id=77f8a6fb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f8a6fb",
  null
  
)

export default component.exports